import React, { useEffect, useState } from "react";

const verdictColor = (verdict) => {
  if (verdict === "safe")        return "#8BF56C";
  if (verdict === "consistent")  return "#8BF56C";
  if (verdict === "suspicious")  return "#F4D03F";
  if (verdict === "inconclusive") return "#F4B942";
  return "#FF5A6E";
};

export const TruthMeter = ({ score = 0, verdict = "safe" }) => {
  const [displayScore, setDisplayScore] = useState(0);
  const color = verdictColor(verdict);
  const radius = 88;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (displayScore / 100) * circumference;

  useEffect(() => {
    let frame;
    const start = performance.now();
    const animate = (now) => {
      const t = Math.min(1, (now - start) / 1200);
      const eased = 1 - Math.pow(1 - t, 3);
      setDisplayScore(Math.round(score * eased));
      if (t < 1) frame = requestAnimationFrame(animate);
    };
    frame = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(frame);
  }, [score]);

  return (
    <div data-testid="truth-meter" className="relative w-56 h-56 flex items-center justify-center">
      <svg width="224" height="224" viewBox="0 0 224 224" className="-rotate-90">
        <circle cx="112" cy="112" r={radius} stroke="rgba(255,255,255,0.08)" strokeWidth="10" fill="none" />
        <circle
          cx="112" cy="112" r={radius}
          stroke={color}
          strokeWidth="10"
          fill="none"
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          style={{ transition: "stroke-dashoffset 0.1s linear", filter: `drop-shadow(0 0 8px ${color})` }}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <span className="font-mono text-5xl font-bold tracking-tighter" style={{ color }} data-testid="truth-score">
          {displayScore}
        </span>
        <span className="text-xs font-mono uppercase tracking-[0.2em] text-[#A1A1AA] mt-1">
          % Veracidad
        </span>
      </div>
    </div>
  );
};
